<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="wide"></app-breadcrumb>

<div class="container">
  <!-- Card Container dos Órgãos -->
  <div class="card">
    <div class="card-body">
      <!-- Título dentro do card -->
      <h3 class="mb-4">Órgãos do Município</h3>

      <!-- Estado: Sem Órgãos -->
      <div *ngIf="orgaos && orgaos.length === 0" class="no-orgaos">
        <!-- Alerta -->
        <div class="alert alert-warning mb-3" role="alert">
          <i class="fa fa-exclamation-triangle"></i> É necessário ao menos um
          órgão cadastrado.
        </div>
        <!-- Mensagem de orientação -->
        <p class="text-muted text-center">
          Adicione um novo órgão clicando no botão "Adicionar Órgão"
        </p>
      </div>

      <!-- Estado: Órgãos Cadastrados -->
      <div
        *ngFor="let orgao of orgaos| slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let first = first; let last = last"
        class="card orgao-card"
        [ngClass]="{'first-card': first, 'last-card': last, 'middle-card': !first && !last}"
      >
        <div class="card-body pt-0 pb-0">
          <!-- Título e Pill -->
          <div class="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 class="card-title text-start">
              {{orgao.descricao}}
            </h5>
            <span
              class="badge-pill"
              [ngClass]="orgao.ativo ? 'pill-success' : 'pill-danger'"
            >
              {{ orgao.ativo ? "ATIVO" : "INATIVO" }}
            </span>
          </div>
          <div class="row">
            <!-- Informações do Órgão -->
            <div class="col-8 card-text mt-1">
              <p>
                <strong>Poder:</strong>
                <span>{{orgao.poder}}</span>
              </p>
              <p>
                <strong>Administração:</strong>
                <span>{{orgao.administracao}}</span>
              </p>
            </div>

            <!-- Botões de Ação -->
            <div class="col-4 actions d-flex justify-content-end align-items-center">
              <button
                [class]="orgao.ativo ? 'btn btn-outline-danger' : 'btn btn-outline-primary'"
                (click)="alterarStatusOrgao(orgao.id, orgao.ativo)"
                [title]="orgao.ativo ? 'Inativar' : 'Ativar'"
              >
                <i [class]="orgao.ativo ? 'fa fa-window-close-o' : 'fa fa-check-square-o'"></i>
              </button>
              <button
                class="btn btn-outline-primary"
                (click)="openModalXl(cadastroOrgao, orgao)"
                title="Editar"
              >
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginação dentro do card -->
      <div class="mt-4 d-flex justify-content-center" *ngIf="orgaos.length > pageSize">
        <ngb-pagination 
          [(page)]="page"
          [pageSize]="pageSize"  
          [maxSize]="12"
          [collectionSize]="orgaos.length">
        </ngb-pagination>
      </div>

      <!-- Botões de Ação dentro do card -->
      <div class="mt-4 d-flex justify-content-between">
        <button type="button" class="btn btn-outline-primary" (click)="voltar()">
          Voltar
        </button>
        <button class="btn btn-primary" (click)="openModalXl(cadastroOrgao, null)">
          Adicionar Órgão
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #cadastroOrgao let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">{{orgao.id ? 'Editar Órgão' : 'Novo Órgão'}}</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações Básicas</h6>
    
    <form #servForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="cnpj_orgao" class="form-label">CNPJ</label>
            <input type="text" id="cnpj_orgao" class="form-control" [(ngModel)]="orgao.cnpj" name="cnpj_orgao" 
                   mask="00.000.000/0000-00" placeholder="00000-000" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="descricao" class="form-label">DESCRIÇÃO</label>
            <input type="text" id="descricao" class="form-control" [(ngModel)]="orgao.descricao" name="descricao" 
                   placeholder="Placeholder" required>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="poder" class="form-label">PODER (PARTIÇÃO)</label>
            <ng-select [items]="poderes" [appendTo]="'body'" name="poder" placeholder="Executivo" 
                       id="poder" [(ngModel)]="orgao.poder" [clearable]="false">
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="administracao" class="form-label">ADMINISTRAÇÃO</label>
            <ng-select [items]="administracoes" name="administracao" placeholder="Placeholder" 
                       id="administracao" [(ngModel)]="orgao.administracao" [clearable]="false">
            </ng-select>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')">
        Voltar
      </button>
      <button type="button" class="btn btn-primary"
              (click)="atualizarOuCadastrar(modal)"
              [disabled]="!orgao.cnpj || !orgao.descricao || !orgao.poder || !orgao.administracao">
        {{orgao.id ? 'Atualizar' : 'Cadastrar'}}
      </button>
    </div>
  </div>
  
  <ngx-spinner></ngx-spinner>
</ng-template>
<ngx-spinner></ngx-spinner>
